import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pushWithQuery as push } from 'utils/routing';

import LoadingSection from 'components/LoadingSection';

import * as baseActions from 'actions/base';
import * as driverActions from 'actions/drivers';
import * as userActions from 'actions/users';
import * as vehicleActions from 'actions/vehicles';
import * as dedicatedContractActions from 'actions/dedicated-contracts';

import { getCurrentCarrier, isLoading } from 'redux/modules/carrier-section/selectors';

import {
  vehiclesIncreasingBySize,
  contactsIncreasingAlphabetical,
  contractsIncreasingByVehiclePlateNumber,
} from 'utils/sort';

import { getAllRoutePairs } from 'reselects';

import { updateCarrier } from 'actions/carriers';

import { preserveScroll } from 'utils/router';

import MainContent from 'components/MainContent';
import CarrierDetails from 'components/CarrierDetails';

import { openFinishedWithFilter } from 'redux/modules/finished-journeys/effects';
import {
  carrierSectionMounted,
  carrierSectionUnMounted,
  carrierUpdated,
} from 'redux/modules/carrier-section/effects';

import config from 'config';
import styled from 'styled-components';

const actionCreators = {
  ...driverActions,
  ...userActions,
  ...baseActions,
  ...vehicleActions,
  ...dedicatedContractActions,
  updateCarrier,
  openFinishedWithFilter,
  carrierSectionMounted,
  carrierSectionUnMounted,
  carrierUpdated,
};

const MainContentStyled = styled(MainContent)`
  padding: 0 1rem;
`;
class CarrierDetailsContainer extends Component {
  constructor(props) {
    super(props);

    this.handleUpdateDriver = this.handleUpdateDriver.bind(this);
    this.handleUpdateCarrier = this.handleUpdateCarrier.bind(this);
  }

  componentDidMount() {
    const { match, carrierSectionMounted } = this.props;
    const { id } = match.params;
    carrierSectionMounted({ id });
  }

  componentWillUnmount() {
    const { carrierSectionUnMounted } = this.props;
    carrierSectionUnMounted();
  }

  async handleUpdateDriver(data) {
    try {
      await this.props.updateDriver(data);
    } catch (e) {
      console.error('error updating driver: ', e);
    }
  }

  async handleUpdateCarrier(data) {
    try {
      await this.props.updateCarrier(data);
    } catch (e) {
      console.error('error updating carrier: ', e);
    }
  }

  render() {
    const {
      query = {},
      subPath,
      subPathAction,
      checkUsername,
      createUser,
      createDriver,
      removeDriver,
      dedicatedContracts,
      updateDriverUser,
      updateUser,
      createVehicle,
      updateVehicle,
      removeVehicle,
      currentCarrier,
      createDedicatedContract,
      fetchDedicatedContracts,
      updateExceptionsDedicatedContract,
      finishDedicatedContract,
      allRoutes,
      match,
      openFinishedWithFilter,
      loading,
      isContractSectionDisabled,
      isDocumentSectionDisabled,
      isUuidSectionDisabled,
    } = this.props;

    const id = parseInt(match.params.id, 10);
    if (isNaN(id)) return <></>;
    const driver_id = parseInt(match.params.driver_id, 10);
    const vehicle_id = parseInt(match.params.vehicle_id, 10);
    const contract_id = parseInt(match.params.contract_id, 10);

    if (loading) {
      return <LoadingSection />;
    }

    if (!currentCarrier) {
      return null;
    }

    return (
      <MainContentStyled>
        <CarrierDetails
          carrier={currentCarrier}
          drivers={currentCarrier.drivers.sort(contactsIncreasingAlphabetical)}
          vehicles={currentCarrier.vehicles.sort(vehiclesIncreasingBySize).filter((v) => !!v)}
          documents={currentCarrier.documents}
          dedicatedContracts={dedicatedContracts.sort(contractsIncreasingByVehiclePlateNumber)}
          subPath={subPath}
          subPathAction={subPathAction}
          onCloseModal={() =>
            push({ pathname: `${config.BASE_ROUTE}carrier/${id}`, query, ...preserveScroll })
          }
          onEditCarrier={() => push({ pathname: `${config.BASE_ROUTE}carrier/${id}/edit`, query })}
          onNewDriver={() =>
            push({ pathname: `${config.BASE_ROUTE}carrier/${id}/driver/new`, query })
          }
          onNewContract={() =>
            push({
              pathname: `${config.BASE_ROUTE}carrier/${id}/contract/new`,
              query,
              ...preserveScroll,
            })
          }
          onNewVehicle={() =>
            push({ pathname: `${config.BASE_ROUTE}carrier/${id}/vehicle/new`, query })
          }
          onEditDriver={(driverId) =>
            push({ pathname: `${config.BASE_ROUTE}carrier/${id}/driver/${driverId}`, query })
          }
          onEditVehicle={(vehicleId) =>
            push({ pathname: `${config.BASE_ROUTE}carrier/${id}/vehicle/${vehicleId}`, query })
          }
          onEditContract={(contractId) =>
            push({
              pathname: `${config.BASE_ROUTE}carrier/${id}/contract/${contractId}`,
              query,
              ...preserveScroll,
            })
          }
          onFilterCarrier={() => {
            openFinishedWithFilter({
              carrier: currentCarrier
                ? {
                    id: currentCarrier.id,
                    label: currentCarrier.name,
                  }
                : null,
            });
          }}
          onFilterDriver={(driver) => {
            openFinishedWithFilter({
              driver: driver
                ? {
                    id: driver.id,
                    label: driver.contact_name,
                  }
                : null,
            });
          }}
          selectedDriver={driver_id}
          selectedVehicle={vehicle_id}
          selectedContract={contract_id}
          checkUsername={checkUsername}
          createUser={createUser}
          createDriver={createDriver}
          removeDriver={removeDriver}
          updateDriver={this.handleUpdateDriver}
          updateCarrier={this.handleUpdateCarrier}
          updateDriverUser={updateDriverUser}
          updateUser={updateUser}
          createVehicle={createVehicle}
          updateVehicle={updateVehicle}
          removeVehicle={removeVehicle}
          createDedicatedContract={createDedicatedContract}
          fetchDedicatedContracts={fetchDedicatedContracts}
          updateExceptionsDedicatedContract={updateExceptionsDedicatedContract}
          finishDedicatedContract={finishDedicatedContract}
          allRoutes={allRoutes}
          match={match}
          isContractSectionDisabled={isContractSectionDisabled}
          isDocumentSectionDisabled={isDocumentSectionDisabled}
          isUuidSectionDisabled={isUuidSectionDisabled}
        />
      </MainContentStyled>
    );
  }
}

CarrierDetailsContainer.propTypes = {
  query: PropTypes.object,
  subPath: PropTypes.string,
  subPathAction: PropTypes.string,
  updateCarrier: PropTypes.func,
  checkUsername: PropTypes.func,
  createUser: PropTypes.func,
  createDriver: PropTypes.func,
  updateDriver: PropTypes.func,
  removeDriver: PropTypes.func,
  dedicatedContracts: PropTypes.array,
  updateDriverUser: PropTypes.func,
  updateUser: PropTypes.func,
  createVehicle: PropTypes.func,
  updateVehicle: PropTypes.func,
  removeVehicle: PropTypes.func,
  currentCarrier: PropTypes.object,
  createDedicatedContract: PropTypes.func,
  fetchDedicatedContracts: PropTypes.func,
  updateExceptionsDedicatedContract: PropTypes.func,
  finishDedicatedContract: PropTypes.func,
  allRoutes: PropTypes.array,
  match: PropTypes.object,
  openFinishedWithFilter: PropTypes.func,
  carrierSectionMounted: PropTypes.func,
  carrierSectionUnMounted: PropTypes.func,
  carrierUpdated: PropTypes.func,
  loading: PropTypes.bool,
};

export default connect((state, ownProps) => {
  return {
    loading: isLoading(state),
    currentCarrier: getCurrentCarrier(state),
    allRoutes: getAllRoutePairs(state),
    dedicatedContracts: state.dedicatedContracts.results || [],
  };
}, actionCreators)(CarrierDetailsContainer);
